export * from './zeit.component';
export * from './zeit.component.module';